











import store from '../../../store'
import DataTable from '../../../components/DataTable.vue'
import PageTitle from '../../../components/PageTitle.vue'
import Table8 from '../tables/Table8.vue'
import Table9 from '../tables/Table9.vue'
import { stockCalculations } from '../../../mixins/mixins'
import dayjs from 'dayjs'

export default {
  mixins: [stockCalculations],
  data () {
    return {
      name: 'Paddock 1',
      date: dayjs().format('YYYY-MM-DD'),
      paddock: {
        size: 0,
        currentFeed: 0,
        quality: null,
        wastage: 0,
        growth: 0
      },
      stock1: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      stock2: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      stock3: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      results: {
        intake: 0,
        growth: 0,
        days: 1
      },
      theaders: [
        { text: 'Field', value: 'label' },
        { text: 'Data', value: 'data.value' },
        { text: 'Calculations & comments', value: 'notes.message' }
      ]
    }
  },

  // Populate on create if data exists
  created: function (this:any) {
    const stored = store.state.simplePasture2
    if (stored !== null) {
      this.name = stored.name
      this.date = stored.date
      this.paddock = stored.paddock
      this.stock1 = stored.stock1
      this.stock2 = stored.stock2
      this.stock3 = stored.stock3
      this.results = stored.results
      this.theaders = stored.theaders
    }
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateSimplePasture2', this.$data)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateSimplePasture2', this.$data)
  },

  computed: {
    tdata: {
      get: function (this:any) {
        let tdataArr:any = []

        // PADDOCK DETAILS

        let paddockArr:any[] = [
          {
            category: 'paddock',
            code: 'size',
            alpha: 'a',
            label: 'Paddock size',
            data: {
              display: 'input',
              type: 'number',
              value: this.paddock.size,
              suffix: 'ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'currentFeed',
            alpha: 'b',
            label: 'Current feed on offer (FOO)',
            data: {
              display: 'input',
              type: 'number',
              value: this.paddock.currentFeed,
              suffix: 'Kg DM/ha'
            },
            notes: {
              message: 'See Table 8 for help',
              title: 'Table 8 - Approximate relationship between pasture height and kg green DM/ha (Prograze)',
              table: Table8
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'quality',
            alpha: 'c',
            label: 'Pasture quality',
            data: {
              display: 'select',
              type: 'string',
              value: this.paddock.quality,
              items: [
                '40% dig, 4.8 MJ ME/kg - Dry (Dead)',
                '50% dig, 6.5 MJ ME/kg - Dry, perennial',
                '60% dig, 8.2 MJ ME/kg  - Gone to seed',
                '70% dig, 10 MJ ME/kg - Green, grassy',
                '75% dig, 10.8 MJ ME/kg - Green, 15-30% clover',
                '80% dig - 11.6 MJ ME/kg - Green, 60% clover'
              ]
            },
            notes: {
              message: 'See the AWI Feed on Offer Library for help.',
              link: 'http://www.feedonofferlibrary.com'
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'wastage',
            alpha: 'd',
            label: 'Consumption wastage factor',
            data: {
              display: 'input',
              type: 'number',
              value: this.paddock.wastage,
              suffix: '%'
            },
            notes: {
              message: 'When stock graze pastures, losses occur through trampling and fouling and is commonly 15—40% of consumption. Use low wastage values for shorter pastures, rotational grazing and dry paddocks and higher values if rank pasture, set stocked and wet paddocks.',
              link: null
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'growth',
            alpha: 'e',
            label: 'Pasture growth',
            data: {
              display: 'input',
              type: 'number',
              value: this.paddock.growth,
              suffix: 'Kg DM/ha/day'
            },
            notes: {
              message: 'See Table 9 for help',
              title: 'Table 9 - Monthly pasture growth rate estimates (Prograze)',
              table: Table9
            },
            hidden: false
          }
        ]

        // ANIMAL CONSUMPTION

        let stockArr:any[] = []
        let alphas = [['f', 'g'], ['h', 'i'], ['j', 'k']]
        for (let i = 1; i <= 3; i++) {
          let currentStock = i === 1 ? this.stock1 : i === 2 ? this.stock2 : this.stock3
          let intakeEnergy = this.getPastureIntakeEnergy(currentStock)
          currentStock.intake = intakeEnergy[0]
          currentStock.energy = intakeEnergy[1]
          let hidden = i > 1
          let stock = [
            {
              category: 'stock ' + i,
              code: 'type',
              label: 'Stock type',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.type,
                items: ['Cows', 'Weaner Cattle', 'Ewes / Wethers', 'Lambs']
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'weight',
              label: 'Average weight',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.weight,
                items: this.getWeights(currentStock.type),
                suffix: 'kg/Hd'
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'state',
              label: 'Physiological state',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.state,
                items: this.getPhysiologicalState(currentStock.type)
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'pregnancy',
              label: 'Twins / singles / not applicable',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.pregnancy,
                items: currentStock.type === 'Ewes / Wethers' && currentStock.state !== 'Dry' ? ['Twins', 'Singles'] : ['Not Applicable']
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'number',
              alpha: alphas[i - 1][0],
              label: 'Number of animals grazing',
              data: {
                display: 'input',
                type: 'number',
                value: currentStock.number
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'intake',
              alpha: alphas[i - 1][1],
              label: 'Estimated pasture intake (kg DM/Hd/day)',
              data: {
                display: 'text',
                type: 'number',
                value: currentStock.intake
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'energy',
              label: 'Maintenance energy required (MJ ME/Hd/day)',
              data: {
                display: 'text',
                type: 'number',
                value: currentStock.energy
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            }
          ]
          stockArr = stockArr.concat(stock)
        }

        // RESULTS

        let resultsArr = [
          {
            category: 'results',
            code: 'intake',
            alpha: 'l',
            label: 'Daily intake per ha + wastage (Kg DM/ha/day)',
            data: {
              display: 'text',
              type: 'number',
              value: this.results.intake,
              items: null
            },
            notes: {
              message: '(f × g + h × i + j × k) × (1 + d) ÷ a',
              link: null
            },
            hidden: false
          },
          {
            category: 'results',
            code: 'growth',
            alpha: 'm',
            label: 'Growth minus intake (KG DM/ha/day)',
            data: {
              display: 'text',
              type: 'number',
              value: this.results.growth
            },
            notes: {
              message: 'e − l',
              link: null
            },
            hidden: false
          },
          {
            category: 'results',
            code: 'days',
            alpha: 'n',
            label: 'Number of days in this paddock',
            data: {
              display: 'input',
              type: 'number',
              value: this.results.days
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            category: 'results',
            code: 'final',
            style: 'green white--text font-weight-bold',
            label: 'Estimated feed on offer in ' + this.results.days + ' days (Kg/ha)',
            data: {
              display: 'text',
              type: 'number',
              value: this.results.final
            },
            notes: {
              message: 'b + (m × n)',
              link: null
            },
            hidden: false
          }
        ]

        tdataArr = paddockArr.concat(stockArr, resultsArr)
        return tdataArr
      },
      set: function (this:any, newValue:any) {
        // Filter each category into seperate array
        let paddock = newValue.filter((e:any) => e.category === 'paddock')
        let stock1 = newValue.filter((e:any) => e.category === 'stock 1')
        let stock2 = newValue.filter((e:any) => e.category === 'stock 2')
        let stock3 = newValue.filter((e:any) => e.category === 'stock 3')
        let results = newValue.filter((e:any) => e.category === 'results')
        // Assign new value to category variables
        paddock.forEach((e:any) => { this.paddock[e.code] = e.data.value })
        stock1.forEach((e:any) => { this.stock1[e.code] = e.data.value })
        stock2.forEach((e:any) => { this.stock2[e.code] = e.data.value })
        stock3.forEach((e:any) => { this.stock3[e.code] = e.data.value })
        results.forEach((e:any) => { this.results[e.code] = e.data.value })
        // Get results
        this.getResults()
      }
    }
  },

  methods: {
    // Get the final results from previous calculations
    getResults: function (this:any) {
      // Daily intake
      this.results.intake = ((this.stock1.intake * this.stock1.number) +
                            (this.stock2.intake * this.stock2.number) +
                            (this.stock3.intake * this.stock3.number)) *
                            (1 + (this.paddock.wastage / 100)) /
                            this.paddock.size || 0
      // Growth
      this.results.growth = this.paddock.growth - this.results.intake || 0
      // Estimated feed on offer
      this.results.final = parseInt(this.paddock.currentFeed) + (this.results.growth * parseInt(this.results.days)) || 0
    },

    // Update the tdata with new values
    update: function (this:any, row:any) {
      let updatedtData = this.tdata
      let oldRow = updatedtData.filter((e:any) => e.category === row.category && e.code === row.code)
      updatedtData[this.tdata.indexOf(oldRow[0])] = row
      this.tdata = updatedtData
      this.tdata.filter((e:any) => e.category === row.category).forEach((e:any) => { e.hidden = false })
    },

    // Load scenario data
    loadScenario: function (this:any, item:any) {
      this.tdata = item.data1
    }
  },

  components: {
    DataTable, PageTitle
  }
}
